import { useCallback, useState } from 'react';
import monitoring from '../common/libs/monitoring';
import useApiClient from './useApiClient';

/**
 * 人気キーワードに関するHooks
 */
export function usePopularKeywords() {
  const { apiClient } = useApiClient();

  const [popularKeywords, setPopularKeywords] = useState<string[]>([]);

  const clearPopularKeywords = useCallback(async () => {
    setPopularKeywords([]);
  }, []);

  const fetchPopularKeywords = useCallback(async () => {
    try {
      const res = await apiClient('/api/search-keyword/popular', {
        method: 'GET',
      });
      if (res.ok) {
        const data = await res.json();
        setPopularKeywords(data);
      } else {
        throw new Error();
      }
    } catch (e) {
      monitoring.notify({
        name: `API ERROR DETECTED ${e}`,
        message: '人気キーワードの取得に失敗しました。',
      });
    }
  }, [apiClient]);

  return {
    popularKeywords,
    clearPopularKeywords,
    fetchPopularKeywords,
  };
}
